import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import Folders from './Folders/index'
// eslint-disable-next-line import/extensions
import Pastas from './Folders/pastaConteudo'
import Videos from './videos'
import User from './user'
import ModuloTreStore from './ModuloTrei/moduloTreStore'
import ModuloChatBooster from './chat-booster/index'
import ModuloChatBoosterIntegrations from './integracoes-chat-booster/index'
import StoreCallActions from './call_actions_vsl'
import StoreAppHelperTour from './app-helper-tour'
import storePagamentos from './pagamentos'
import storeNotifications from './notifications'
import appPayment from './Payment'
import appUserAddress from './UserAddress'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    Folders,
    Pastas,
    Videos,
    User,
    ModuloTreStore,
    AppChatbooster: ModuloChatBooster,
    AppChatboosterIntegration: ModuloChatBoosterIntegrations,
    callActions: StoreCallActions,
    appHelperTour: StoreAppHelperTour,
    storePagamentos,
    storeNotifications,
    appPayment,
    appUserAddress,
  },
  strict: process.env.DEV,
})
